import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { Radio } from 'antd';
import './langToggle.less';

const LanguageToggle = (props) => {
  const { languages, setActiveLanguage, activeLanguage } = props;
  const defaultValue = languages.length > 0 && activeLanguage && activeLanguage.code
  return (
    <div className="toggle-button">
      <Radio.Group>
        {languages.map(lang => (
          <Radio.Button
            checked={lang.code === defaultValue}
            key={lang.code} value={lang.code}
            onClick={() => setActiveLanguage(lang.code)}
          >
            {(lang.code).toUpperCase()}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  )
}

export default withLocalize(LanguageToggle)
